export enum ViewLayout {
  Drawer = 'drawer',
  Column = 'column',
}
